import { render, staticRenderFns } from "./m-editor.vue?vue&type=template&id=3fefd8a0&"
import script from "./m-editor.vue?vue&type=script&lang=js&"
export * from "./m-editor.vue?vue&type=script&lang=js&"
import style0 from "./m-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports